export enum SuspendStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  SOFT_DELETED = 'SOFT_DELETED',
}
